import { useEffect, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useT } from "@/i18n";
import { usePageMeta } from "@/lib/format";
import { getPracticeConfigs } from "./practiceConfigs";
import { PracticeFlow } from "./PracticeFlow";

export default function PracticeRunner() {
  const { key } = useParams();
  const navigate = useNavigate();
  const t = useT();
  const configs = useMemo(() => getPracticeConfigs(t), [t]);
  const cfg = configs[key];
  usePageMeta(cfg ? cfg.title : "Practice");

  useEffect(() => {
    if (!cfg) navigate("/app/practices", { replace: true });
  }, [cfg, navigate]);

  if (!cfg) return null;
  return (
    <div className="py-2">
      <PracticeFlow key={cfg.practiceKey} cfg={cfg} />
    </div>
  );
}
